wbApp.filter('urlButton', function () {
    return function (input) {
        if (input === "==group==") {
            return '<div class="btn btn-warning btn-xs btn-width-57" role="button">Více <i class="fa fa-caret-down"></i></div>';
        } else if (!!input && input.startsWith('https://')) {
            return '<a class="btn btn-success btn-xs btn-width-57" href="' + input + '" role="button" target="_blank"><i class="fa fa-globe"></i> Více <i class="fa fa-caret-right"></i></a>';
        } else if (!!input && !input.startsWith('https://')) {
            return '<a class="btn btn-success btn-xs btn-width-57" href="https://' + input + '" role="button" target="_blank"><i class="fa fa-globe"></i> Více <i class="fa fa-caret-right"></i></a>';
        } else {
            return '';
        }
    };
});